import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VToolbar,{staticClass:"baseToolbar_v2",style:([
    _vm.$vuetify.breakpoint.smAndUp ? _vm.secondToolbarStyles : { height: 'auto' }
  ]),attrs:{"text":"","dark":"","color":"light-blue darken-4","flat":""}},[_vm._t("toolbarContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }